import 'css-chunksrc/client/scenes/workloads/wbs/project/styles.scss';export default {
  "project": "_project_8b6xc_1",
  "name": "_name_8b6xc_8",
  "hovered": "_hovered_8b6xc_9",
  "zone": "_zone_8b6xc_13",
  "icon": "_icon_8b6xc_28",
  "toggleArrowBox": "_toggleArrowBox_8b6xc_35",
  "details": "_details_8b6xc_41",
  "detail": "_detail_8b6xc_41",
  "main": "_main_8b6xc_61",
  "wrapper": "_wrapper_8b6xc_84",
  "status": "_status_8b6xc_104",
  "contextualMenu": "_contextualMenu_8b6xc_110",
  "displayedContextualMenu": "_displayedContextualMenu_8b6xc_119"
};